var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"anchor-container",class:{
    isPackUp: _vm.isPackUp,
    ischangearea: _vm.ischangearea,
    packUpNotChange: _vm.isPackUp && !_vm.ischangearea,
    packAndChange: _vm.isPackUp && _vm.ischangearea,
  },attrs:{"id":"container"}},[_c('aheader',{staticClass:"anchor-header"}),_c('asideLeft',{staticClass:"anchor-asideleft"}),_c('acenter',{staticClass:"anchor-center",on:{"hook:mounted":_vm.acenterMounted}}),_c('videoArea',{staticClass:"video-container"}),_c('asideRight',{staticClass:"anchor-asideright"}),_c('check'),(_vm.content)?_c('tips',{attrs:{"content":_vm.content,"time":_vm.time}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }